import React from "react";
import styles from "./LoginLink.module.scss";
import { getLoginUrl } from "@utils/getLoginUrl";
import assetLoader from "@utils/internalImageLoder";
import ImageAtom from "@components/atoms/Image";

type LoginLinkProps = {
  isMobile: boolean;
};

const LoginLink = ({ isMobile }: LoginLinkProps) => {
  const handleLogin = () => {
    const currentUrl = window.location.href;
    window.location.href = getLoginUrl(currentUrl);
  };
  return (
    <div onClick={handleLogin} className={styles.loginLink}>
      {isMobile ? (
        <span>Login</span>
      ) : (
        <span>Login to check ACKO Drive price</span>
      )}
      <ImageAtom
        src={`${assetLoader()}/icons/chevron-right.svg`}
        alt="Arrow"
        width={24}
        height={24}
      />
    </div>
  );
};

export default LoginLink;
